interface AppConfig {
  test: {
    DOMAIN: string;
    APP_URL: string;
    BASE_URL: string;
    BASE_CLUSTER_URL: string;
  }
  development: {
    DOMAIN: string;
    APP_URL: string;
    BASE_URL: string;
    BASE_CLUSTER_URL: string;
  },

  production: {
    DOMAIN: string;
    APP_URL: string;
    BASE_URL: string;
    BASE_CLUSTER_URL: string;
  }
  // Define other configuration options with their types
}

const appConfig: AppConfig = {
  development: {
    DOMAIN: "keymaster.pt",
    APP_URL: new URL("https://www.keymaster.pt").href,
    //BASE_URL: "http://asuaempresa.qa.keymaster.pt:8080/kss",
    BASE_URL: "https://asuaempresa.qa.keymaster.pt/kss",
    // BASE_URL: "http://checkpoint.qa.keymaster.pt:8080/kss",
    // BASE_URL: "http://clickstop.qa.keymaster.pt:8080/kss",
    //BASE_CLUSTER_URL: "http://asuaempresa.qa.keymaster.pt:8080",
    BASE_CLUSTER_URL: "https://asuaempresa.qa.keymaster.pt",
  },
  production: {
    DOMAIN: "keymaster.pt",
    APP_URL: new URL("https://www.keymaster.pt").href,
    BASE_URL: "/kss",
    BASE_CLUSTER_URL: "",
  },
  test: {
    DOMAIN: "keymaster.pt",
    APP_URL: new URL("https://www.keymaster.pt").href,
    BASE_URL: "http://checkpoint.qa.keymaster.pt:8080/kss",
    BASE_CLUSTER_URL: "http://checkpoint.qa.keymaster.pt:8080",
  },
};

export default appConfig[process.env.NODE_ENV || 'development'];